import { createBrowserRouter, RouterProvider } from 'react-router';

import StoreLayout from './layouts/store/store.layout';

import Home from './routes/home/home.component';
import Shop from './routes/shop/shop.component';
import Authentication from './routes/authentication/authentication.component';
import Checkout from './routes/checkout/checkout.component';
import Category from './routes/category/category.component';

const router = createBrowserRouter([
  {
    path: '/',
    Component: StoreLayout,
    children: [
      { index: true, Component: Home },
      {
        path: 'shop',
        children: [
          { index: true, Component: Shop },
          { path: ':categoryId', Component: Category }
        ]
      },
      { path: 'auth', Component: Authentication },
      { path: 'checkout', Component: Checkout },
    ]
  }
]);

const App = () => (
  <RouterProvider router={router} />
);

export default App;
